var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewEdit = function SvgReviewEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.583 11.861c0-.107.087-.195.194-.195h4.861c.108 0 .195.088.195.195v.778a.194.194 0 0 1-.195.194h-4.86a.194.194 0 0 1-.195-.194zM9.968 1.068c-.316-.015-.637.099-.878.34l-.975.975-.031.032-6.576 6.576a1.17 1.17 0 0 0-.342.825v2.434c0 .322.261.583.583.583h2.434c.31 0 .606-.123.825-.341l6.601-6.602.007-.007.975-.974.041-.044c.414-.458.4-1.165-.04-1.607l-1.851-1.85a1.16 1.16 0 0 0-.773-.34m-.053 1.166 1.85 1.85-.974.974-1.85-1.85zm.051 3.65-5.783 5.782h-1.85v-1.85l5.783-5.783z"
  })));
};
export default SvgReviewEdit;